import * as React from 'react';
import { Box } from '../../designSystem/components/box';
import { Flex } from '../../designSystem/components/flex';
import { RichText } from '../../designSystem/components/richEditor/richText';
import { UserAssignmentsDocumentOptions } from '../../generated/types';
import { isValidColor } from '../../util/color';
import { useTranslate } from '../../util/dependencies/dependencies';
import { isNonEmptyString } from '../../util/string';

export function getSubtitlesStyle(
    options: Pick<UserAssignmentsDocumentOptions, 'subtitleColor' | 'titleFontFamily'>
) {
    return {
        color: isValidColor(options.subtitleColor) ? options.subtitleColor : '$gray800',
        fontFamily: options.titleFontFamily || 'Open Sans',
        fontSize: '14px',
        fontWeight: '700',
        textTransform: 'uppercase'
    };
}

interface IDocumentInformationsProps {
    isAso?: boolean;
    informationsContent: string;
    informationsTitle: string;
    options: Pick<
        UserAssignmentsDocumentOptions,
        'showInformations' | 'subtitleColor' | 'titleFontFamily'
    >;

    renderText(text: string): string;
}

export const DocumentInformations = (props: IDocumentInformationsProps) => {
    const translate = useTranslate();

    return props.options.showInformations ? (
        <Flex
            css={{
                background: props.isAso ? undefined : 'white',
                borderRadius: '$2',
                px: props.isAso ? '0' : '$3',
                py: '$4'
            }}
            direction="column"
            gap={props.isAso ? '1' : '3'}
            width={1}
        >
            <Box
                css={{
                    ...getSubtitlesStyle(props.options),
                    textAlign: 'center'
                }}
                width={1}
            >
                {isNonEmptyString(props.informationsTitle)
                    ? props.informationsTitle
                    : translate('informations_22954')}
            </Box>

            {isNonEmptyString(props.informationsContent) && (
                <>
                    <Box
                        css={{
                            '& .h-rich-text > p': {
                                margin: '0'
                            }
                        }}
                    >
                        <RichText text={props.renderText(props.informationsContent)} />
                    </Box>
                </>
            )}
        </Flex>
    ) : null;
};
